import React from "react";
import { useReveal } from "../hooks/useReveal";

const ContactSection = () => {
  const [leadRef, leadIn] = useReveal();
  const [panelRef, panelIn] = useReveal();

  return (
    <section
      id="contact"
      className="relative py-28 sm:py-36 bg-ink text-paper overflow-hidden ct-grain"
      style={{ background: "radial-gradient(130% 100% at 15% 0%,#2E2668,#1B1540 55%,#120E32)" }}
    >
      <div className="absolute rounded-full blur-3xl pointer-events-none" style={{ width: "560px", height: "560px", top: "-180px", left: "2%", background: "rgba(126,79,208,.42)" }} />
      <div className="absolute rounded-full blur-3xl pointer-events-none" style={{ width: "460px", height: "460px", bottom: "-180px", right: 0, background: "rgba(216,7,60,.24)" }} />
      <div className="relative z-10 max-w-6xl mx-auto px-5 sm:px-8 grid lg:grid-cols-12 gap-16 items-center">
        <div ref={leadRef} className={`lg:col-span-7 reveal ${leadIn ? "in" : ""}`}>
          <h2 className="font-display font-normal text-4xl sm:text-6xl leading-[1.03] tracking-tight">
            Something worth<br />building? <span className="italic text-rose">Let's connect.</span>
          </h2>
        </div>
        <div ref={panelRef} className={`lg:col-span-5 reveal ${panelIn ? "in" : ""}`} style={{ transitionDelay: ".12s" }}>
          <div className="ct-panel">
            <div className="ct-field">
              <span className="ct-ic">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M12 21s7-6.3 7-11a7 7 0 1 0-14 0c0 4.7 7 11 7 11z" />
                  <circle cx="12" cy="10" r="2.5" />
                </svg>
              </span>
              <div>
                <p className="ct-lbl">Location</p>
                <p className="ct-val">
                  Yuvi Labs and Technologies<br />1st floor, Kaizen Workspace, 5AC-614,<br />2nd Cross Rd, HRBR Layout 2nd Block,<br />Banaswadi, Bengaluru 560043
                </p>
              </div>
            </div>
            <div className="ct-field">
              <span className="ct-ic">
                <svg width="19" height="19" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.8 19.8 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6A19.8 19.8 0 0 1 2.12 4.18 2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.13.81.36 1.6.7 2.34a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.74-1.74a2 2 0 0 1 2.11-.45c.74.34 1.53.57 2.34.7A2 2 0 0 1 22 16.92z" />
                </svg>
              </span>
              <div>
                <p className="ct-lbl">Phone</p>
                <p className="ct-val"><a href="tel:+917806864478">+91 7806864478</a></p>
              </div>
            </div>
            <a className="ct-mail" href="mailto:yuva.dev.in@gmail.com?subject=Let's Collaborate - Project Inquiry">
              <span className="ct-mail-txt">
                <span className="ct-lbl">Email us</span>
                <span className="ct-em">yuva.dev.in@gmail.com</span>
              </span>
              <span className="ct-plane">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M22 2 11 13" />
                  <path d="M22 2 15 22l-4-9-9-4 20-7z" />
                </svg>
              </span>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;